import { Link } from "react-router-dom";
import { useApp } from "@/lib/AppContext";

const T = {
  ar: {
    badge: "خدماتنا",
    title: "ماذا نغسل لك؟",
    subtitle: "نعتني بكل قطعة كأنها لنا — من الملابس اليومية حتى أثمن مقتنياتك",
    orderBtn: "اطلب الآن",
  },
  en: {
    badge: "Our Services",
    title: "What Do We Clean For You?",
    subtitle: "We care for every item as if it were our own — from daily wear to your most precious possessions",
    orderBtn: "Order Now",
  }
};

const SERVICES = [
  {
    id: "clothes",
    icon: "👕",
    image: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?w=400&h=300&fit=crop&fm=webp&q=80",
    ar: "غسيل وكوي الملابس",
    en: "Clothes Washing & Ironing",
    color: "from-blue-500 to-cyan-500",
  },
  {
    id: "duvets",
    icon: "🛏️",
    image: "https://images.unsplash.com/photo-1586105251261-72a756497a11?w=400&h=300&fit=crop&fm=webp&q=80",
    ar: "غسيل اللحافات",
    en: "Duvet Cleaning",
    color: "from-indigo-500 to-purple-500",
  },
  {
    id: "abayas",
    icon: "🧕",
    image: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=400&h=300&fit=crop&fm=webp&q=80",
    ar: "غسيل العبايات",
    en: "Abaya Cleaning",
    color: "from-purple-500 to-pink-500",
  },
  {
    id: "furnishings",
    icon: "🛋️",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=300&fit=crop&fm=webp&q=80",
    ar: "المفروشات",
    en: "Furnishings",
    color: "from-amber-500 to-orange-500",
  },
  {
    id: "dresses",
    icon: "👗",
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=300&fit=crop&fm=webp&q=80",
    ar: "الفساتين",
    en: "Dresses",
    color: "from-pink-500 to-rose-500",
  },
  {
    id: "shoes",
    icon: "👟",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop&fm=webp&q=80",
    ar: "الأحذية",
    en: "Shoes",
    color: "from-emerald-500 to-teal-500",
  },
  {
    id: "strollers",
    icon: "🍼",
    image: "https://media.base44.com/images/public/6a2b1e20f315b54cdcedf465/2aa3c7b7e_image.png",
    ar: "عربات الأطفال",
    en: "Baby Strollers",
    color: "from-sky-500 to-blue-500",
  },
];

export default function ServicesSection() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const isAr = lang === "ar";

  return (
    <section id="services" className="py-20 bg-secondary/30" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-primary/10 text-primary text-xs font-black px-4 py-2 rounded-full mb-3">
            {tr.badge}
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-foreground mb-2">{tr.title}</h2>
          <p className="text-muted-foreground">{tr.subtitle}</p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {SERVICES.map(service => (
            <div
              key={service.id}
              className="group relative bg-card border border-border rounded-3xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-36 overflow-hidden">
                <img
                  src={service.image}
                  alt={isAr ? service.ar : service.en}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                {/* Gradient overlay */}
                <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-40 group-hover:opacity-50 transition-opacity`} />
                {/* Icon badge */}
                <div className="absolute top-2 start-2 w-9 h-9 bg-white/90 backdrop-blur rounded-xl flex items-center justify-center text-xl shadow-sm">
                  {service.icon}
                </div>
              </div>

              {/* Label */}
              <div className="p-3">
                <p className="font-black text-sm text-foreground text-center leading-snug">
                  {isAr ? service.ar : service.en}
                </p>
              </div>
            </div>
          ))}

          {/* CTA Card */}
          <Link
            to="/laundry"
            className={`group relative bg-gradient-to-br from-primary to-accent rounded-3xl overflow-hidden flex flex-col items-center justify-center p-5 text-center hover:shadow-xl hover:-translate-y-1 transition-all duration-300 min-h-[160px]`}
          >
            <div className="text-4xl mb-2">🧺</div>
            <p className="font-black text-white text-sm leading-snug">{tr.orderBtn}</p>
            <span className="mt-2 text-white/70 text-xs">←</span>
          </Link>
        </div>
      </div>
    </section>
  );
}